import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
    HostListener,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent, Subject, Subscription } from 'rxjs';
import {
    distinctUntilChanged,
    map,
    share,
    takeUntil,
    throttleTime,
} from 'rxjs/operators';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';

type DenseNavigationAppearance = 'default' | 'dense';

@Component({
    selector: 'classic-layout',
    templateUrl: './classic.component.html',
    styleUrls: ['./classic.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ClassicLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    navigationAppearance: DenseNavigationAppearance =
        <DenseNavigationAppearance>(
            localStorage.getItem('denseNavigationAppearance')
        ) ?? 'default';
    opened: boolean = true;

    /**
     * Constructor
     */
    constructor(
        private cdr: ChangeDetectorRef,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    private scrollSubscription: Subscription;
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');

                this.opened = !this.isScreenSmall;
            });
    }

    //============footer effect ===========
    isFooterHidden = false;
    private lastScrollPosition = 0;
    @HostListener('window:scroll', [])
    onWindowScroll() {
        const currentScrollPosition = window.pageYOffset;

        if (
            currentScrollPosition > this.lastScrollPosition &&
            currentScrollPosition > 10
        ) {
            this.isFooterHidden = true;
        } else {
            this.isFooterHidden = false;
        }

        this.lastScrollPosition = currentScrollPosition;
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        //========footer effect===========
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Toggle the navigation appearance
     */
    toggleNavigationAppearance(): void {
        if (this.isScreenSmall) {
            this.opened = !this.opened;
        } else {
            this.navigationAppearance =
                this.navigationAppearance === 'default' ? 'dense' : 'default';
        }

        localStorage.setItem(
            'denseNavigationAppearance',
            this.navigationAppearance
        );
    }
}
function onWindowScroll() {
    throw new Error('Function not implemented.');
}
